import { render, staticRenderFns } from "./SecondAdminComp.vue?vue&type=template&id=6544874e&scoped=true&"
import script from "./SecondAdminComp.vue?vue&type=script&lang=js&"
export * from "./SecondAdminComp.vue?vue&type=script&lang=js&"
import style0 from "./SecondAdminComp.vue?vue&type=style&index=0&id=6544874e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544874e",
  null
  
)

export default component.exports